import React from 'react';
import { ArcDroneMarker } from '@src/core/controllers';
import { SelectedDroneMarkerProps } from './types';

/**
 * Component to render marker for selected drone when it's not on a mission
 */
export const SelectedDroneMarker: React.FC<SelectedDroneMarkerProps> = React.memo(({
  drone,
  onClick,
  isOnMission,
  rotation,
}) => {
  return (
    isOnMission ? (
      <ArcDroneMarker.missionArrow
        key={drone.id}
        position={{
          lat: Number(drone.latitude),
          lng: Number(drone.longitude),
        }}
        onClick={onClick}
        rotation={rotation}
      />
    ) : (
      <ArcDroneMarker.idleArrow
        key={drone.id}
        position={{
          lat: Number(drone.latitude),
          lng: Number(drone.longitude),
        }}
        onClick={onClick}
      />
    ) 
  );
});

SelectedDroneMarker.displayName = 'SelectedDroneMarker';

